import { render } from "./HomeQrTypeDescriptionItem.vue?vue&type=template&id=8fe22f26&scoped=true&ts=true&lang=pug"
import script from "./HomeQrTypeDescriptionItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeQrTypeDescriptionItem.vue?vue&type=script&lang=ts&setup=true"

import "./HomeQrTypeDescriptionItem.vue?vue&type=style&index=0&id=8fe22f26&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe22f26"]])

export default __exports__